import { getFilteredTruthyFieldsObj } from '../../../../shared/utils/sortingAndGroupingUtil';
import { DeepPartial } from '../../../../utils-types';
import { ChallengeFormValues } from '../../../interfaces/ChallengeFormValues';
import { CreateChallengeInfo } from '../../../interfaces/SaveChallengeInfo';
import { convertDatesToApiFormat } from '../../../utils/convertDatesToApiFormat';
import { convertBannersToApiFormat } from './convertBannersToApiFormat';

export const convertChallengeData = (
  data: ChallengeFormValues,
): DeepPartial<CreateChallengeInfo> => {
  const importantDates = convertDatesToApiFormat(data.importantDates);
  const banners = convertBannersToApiFormat(data.banners);

  const apiData = getFilteredTruthyFieldsObj({ ...data, importantDates, banners });

  return apiData as DeepPartial<CreateChallengeInfo>;
};
